function openJobApplicationFormModal() {
    const modal = document.getElementById('ss-job-application-form-modal');
    modal.style.display = 'block';
    document.body.classList.add('modal-open');
    modal.classList.add('active');
    var span = document.getElementsByClassName("ss-close")[0];
      span.onclick = function() {
      modal.style.display = "none";
      document.body.classList.remove('modal-open');
      modal.classList.remove('active'); 
      
    }
  
    // When the user clicks anywhere outside of the modal, close it
      window.onclick = function(event) {
          if (event.target == modal) {
              modal.style.display = "none";
              document.body.classList.remove('modal-open');
              modal.classList.remove('active'); 
          }
      }
    }
    

    const applyNowButton1 = document.getElementById('ss-btn-apply-now');
    const applyNowButton2 = document.getElementById('ss-btn-apply-now2');

    if(applyNowButton1 != null || applyNowButton2 != null){
      applyNowButton1.addEventListener('click', openJobApplicationFormModal);
      applyNowButton2.addEventListener('click', openJobApplicationFormModal);
    }
    
  export {openJobApplicationFormModal};